import { useRef, useLayoutEffect, useCallback } from 'react'
import { resizeAutoGrowTextArea } from '../lib/autoGrowTextArea'

export function AutoGrowTextArea({
  value,
  onChange,
  readOnly,
  placeholder,
  className = '',
  'aria-label': ariaLabel,
}) {
  const ref = useRef(null)

  useLayoutEffect(() => {
    resizeAutoGrowTextArea(ref.current)
  }, [value, readOnly])

  const handleChange = useCallback(
    (e) => {
      resizeAutoGrowTextArea(e.target)
      onChange?.(e)
    },
    [onChange],
  )

  const mergedClass = ['field-auto-grow-textarea', className].filter(Boolean).join(' ')

  return (
    <textarea
      ref={ref}
      rows={1}
      className={mergedClass}
      value={value ?? ''}
      readOnly={readOnly}
      placeholder={placeholder}
      aria-label={ariaLabel}
      onChange={readOnly ? undefined : handleChange}
    />
  )
}
